import axios from 'axios';
import config from 'config.js';

// Constants
const GET_SERVICES_HEALTH_REQUEST = 'dashboard/GET_SERVICES_HEALTH_REQUEST';
const GET_SERVICES_HEALTH_SUCCESS = 'dashboard/GET_SERVICES_HEALTH_SUCCESS';
const GET_SERVICES_HEALTH_FAILURE = 'dashboard/GET_SERVICES_HEALTH_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  servicesHealth: null,

  getServicesHealth: { ...endpoitInitialStatus },
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === GET_SERVICES_HEALTH_REQUEST) {
    state.getServicesHealth = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_SERVICES_HEALTH_SUCCESS) {
    state.getServicesHealth = getEndpointStatus('success');
    state.servicesHealth = action.payload;

    return { ...state };
  }

  if (action.type === GET_SERVICES_HEALTH_FAILURE) {
    state.getServicesHealth = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getServicesHealth() {
  const request = () => { return { type: GET_SERVICES_HEALTH_REQUEST } };
  const success = (res) => { return { type: GET_SERVICES_HEALTH_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_SERVICES_HEALTH_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getServicesHealth();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getServicesHealth: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/health/services`,
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          token: config.healthToken
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
